import {DataContext} from "../Context/DataContext";
import {useState} from "react";
import Navbar from "../Navbar/Navbar";
import Reports from "../Reports";

function AdminReport(){
    const[searchUi,setSearchUi]=useState(false)
    return(

        <DataContext.Provider value={{searchUi,setSearchUi}}>
        <Navbar 
         navId={7}
        childrenPage={<Reports/>}/>
        </DataContext.Provider>
    )
}

export default AdminReport;